module.exports = __webpack_public_path__ + "static/media/border.c1a70fc4.png";